import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import {NbMenuService} from "@nebular/theme";

@Component({
  selector: 'ngx-idraw-footer',
  templateUrl: './idraw-footer.component.html',
  styleUrls: ['./idraw-footer.component.scss']
})
export class IdrawFooterComponent implements OnInit {

  public adminURL = environment.adminURL;
  public website = environment.website;

  constructor(private menuService: NbMenuService) { }
  items = [{ title: 'How It Works' },
    { title: 'Lending Options' },
    { title: 'Line Of Credit' },
    { title: 'Why Irving Fund' },
    { title: 'Contact Us' }]


  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(item=>{
      if(item.item.title === 'How It Works'){
        this.goToLink('https://irvingfund.com/howitworks');
      }
      if(item.item.title === 'Lending Options'){
        this.goToLink('https://irvingfund.com/Lendingoptions');
      }
      if(item.item.title === 'Line Of Credit'){
        this.goToLink('https://irvingfund.com/Lineofcredit');
      }
      if(item.item.title === 'Why Irving Fund'){
        this.goToLink('https://irvingfund.com/WhyIrvingfund');
      }
      if(item.item.title === 'Contact Us'){
        this.goToLink('https://irvingfund.com/contact');
      }

    })
  }


  goToLink(url: string){
    window.open(url, "_blank");
  }

}
